export default function UserMessage({ children }: { children: React.ReactNode }) {
  return (
    <div style={{ display: "flex", justifyContent: "flex-end" }}>
      <div
        className="app-anim-fade-right desktop-glass-bubble"
        style={{
          maxWidth: 640,
          background: "#171717",
          border: "1px solid #2C2B2B",
          borderRadius: "16px 0px 16px 16px",
          padding: "17px 25px",
          fontFamily: "var(--font-urbanist), sans-serif",
          fontWeight: 500,
          fontSize: 16,
          lineHeight: "26px",
          color: "#F2F0ED",
        }}
      >
        {children}
      </div>
    </div>
  );
}
